import * as React from 'react';
import { useProfileStore } from 'src/hooks/profile';
import { useEffect } from 'react';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';

const AccountInformation = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [{ profile_account_information }, { get_profile_account_information }] = useProfileStore();

    useEffect(() => {
        async function fetchHere() {
            await get_profile_account_information();
        }

        fetchHere()
    }, [])

    return (
        <>
            <div id="account-summary" className="card container-fluid account-info-content">
                <div className="account-heading card-header bg-white px-0 py-3">
                    <h4 className='font-apecru font-18 m-0'> Account Information</h4>
                </div>
                <div className='card-body px-0'>
                    {__check(['PROFILE_API_CALL']).render}
                    {
                        profile_account_information && Object.entries(profile_account_information).length > 0 &&
                        !__check(['PROFILE_API_CALL']).status &&
                        <div className="bs5 row summary-content">
                            <div className="col-sm-6 col-md-6 col-lg-6">
                                <div className='mb-2'>
                                    <h4 className='font-apecru font-16 m-0 d-inline-block'> Contact Information
                                    </h4>
                                </div>

                                <div className='bs5 row lh24 mb-4'>
                                    <div className="col-12 d-flex flex-column flex-sm-row mb-2 mb-sm-0">
                                        <div className="font-bold w110">
                                            Name
                                        </div>
                                        <div>
                                            {
                                                profile_account_information.fullName
                                            }
                                        </div>
                                    </div>
                                    <div className="col-12 d-flex flex-column flex-sm-row mb-2 mb-sm-0">
                                        <div className="font-bold w110">
                                            Company
                                        </div>
                                        <div>

                                            {profile_account_information.company}
                                        </div>
                                    </div>
                                    <div className="col-12 d-flex flex-column flex-sm-row mb-2 mb-sm-0">
                                        <div className="font-bold w110">
                                            Job Function
                                        </div>
                                        <div>
                                            {profile_account_information.jobFunction}
                                        </div>
                                    </div>
                                    <div className="col-12 d-flex flex-column flex-sm-row mb-2 mb-sm-0">
                                        <div className="font-bold w110">
                                            Phone
                                        </div>
                                        <div>
                                            {profile_account_information.phoneNumber}

                                        </div>
                                    </div>
                                    <div className="col-12 d-flex flex-column flex-sm-row mb-2 mb-sm-0">
                                        <div className="font-bold w110">
                                            Email
                                        </div>
                                        <div>
                                            {profile_account_information.emailAddress}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-6 col-md-6 col-lg-6'>
                                <div className='bs5 row'>

                                    <div className="col-sm-12 mb-4 mb-md-3">
                                        <div className='mb-2'>
                                            <h4 className='font-apecru font-16 m-0 d-inline-block'> Account  </h4>
                                        </div>

                                        <div className='lh20'>
                                            <div>
                                                {
                                                    profile_account_information.accountNumber
                                                }
                                            </div>
                                            <a className='text-blue2' href={void (0)}>Request to Join Existing Account</a>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 mb-4 mb-md-3">
                                        <div className='mb-2'>
                                            <h4 className='font-apecru font-16 m-0'> Password  </h4>
                                        </div>

                                        <div className='lh20'>
                                            <a className='text-blue2' href={void (0)} id="changePwd"> Change Password </a>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className='mb-2'>
                                            <h4 className='font-apecru font-16 m-0'> Need More Information   </h4>
                                        </div>

                                        <div className='lh20'>
                                            <div>Visit our <a className='text-blue2' href={void (0)}> help page</a>  </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    }
                </div>
            </div>
        </>
    )
}

export default AccountInformation;